import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import HowItWorksSection from '../components/HowItWorksSection';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CommentCaMarchePage = () => {
  return (
    <>
      <Helmet>
        <title>Comment ça marche - Sun-Spot</title>
        <meta name="description" content="Découvrez comment utiliser Sun-Spot en 4 étapes simples : trouvez, visualisez, accédez et partagez vos spots panoramiques préférés." />
        <link rel="canonical" href="https://sun-spot.app/comment-ca-marche" />
      </Helmet>
      
      <div className="pt-16">
        <HowItWorksSection />
        
        {/* Navigation between pages */}
        <div className="bg-amber-50 py-8">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center">
              <Link 
                to="/concept" 
                className="flex items-center space-x-2 text-amber-700 hover:text-amber-900 transition-colors duration-200"
              >
                <ChevronLeft className="w-5 h-5" />
                <span>Le concept</span>
              </Link>
              
              <Link 
                to="/pourquoi-sun-spot" 
                className="flex items-center space-x-2 text-amber-700 hover:text-amber-900 transition-colors duration-200"
              >
                <span>Pourquoi Sun-Spot</span>
                <ChevronRight className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommentCaMarchePage;